import { render, staticRenderFns } from "./ShippingInformationCard.vue?vue&type=template&id=188bb28e&"
import script from "./ShippingInformationCard.vue?vue&type=script&lang=js&"
export * from "./ShippingInformationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports